import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS, whatsappLink } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";

const Item = ({ faq, index, open, onToggle }) => (
  <div className="border-b border-slate-200" data-testid={`faq-item-${index}`}>
    <button
      data-testid={`faq-question-${index}`}
      aria-expanded={open}
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-6 py-6 text-left group"
    >
      <span className={`font-display text-lg sm:text-xl font-semibold tracking-tight transition-colors duration-200 ${open ? "text-[#0055FF]" : "text-slate-900 group-hover:text-[#0055FF]"}`}>
        {faq.q}
      </span>
      <motion.span animate={{ rotate: open ? 45 : 0 }} transition={{ duration: 0.25 }}
        className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-[border-color,background-color] duration-200 ${open ? "border-[#0055FF] bg-[#F0F4FF]" : "border-slate-300 group-hover:border-slate-500"}`}>
        <Plus className={`w-4 h-4 ${open ? "text-[#0055FF]" : "text-slate-500"}`} />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <div className="pb-7 pr-14 text-sm sm:text-base text-slate-600 leading-relaxed" data-testid={`faq-answer-${index}`}>
            {faq.a}
            {faq.whatsapp && (
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="faq-whatsapp-button"
                className="mt-4 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb857] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200">
                Message us on WhatsApp
              </a>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-[#FAFAFA]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading align="center"
            overline="Questions, answered"
            title="Everything you're probably wondering."
            sub="Straight answers in plain English. Can't find your question? Message us on WhatsApp — we reply fast."
          />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-14 border-t border-slate-200">
            {FAQS.map((f, i) => (
              <Item key={i} faq={f} index={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
